(function () {

    //Varibles for the accordion sub menu to open, close and overlay
    const dropdownBtn = document.querySelector(".qld__uninav__item-toggle");
    const dropdownMenu = document.querySelector(".qld__uninav__menu-sub");
    const dropdownInner = document.querySelector(".qld__uninav__menu-sub-inner");
    const overlay = document.querySelector(".qld__main-nav__overlay");
    let isOpen = false;
    const openClass = "qld__uninav__accordion--open";
    const closedClass = "qld__uninav__accordion--closed";
    const overlayOpen = "qld__main-nav__overlay--open";
    const overlayClosed = "qld__main-nav__overlay--closed";
    var searchForm = document.querySelector('.qld__header__search .qld__search-form');

    // Variables for to change list and view all icons
    // const listGroups = document.querySelectorAll('ul.qld__link-columns.qld__uninav__menu-column');
    // const baseSiteUrl = window.location.origin;
    // const subFooterIcon = document.querySelector(".qld__uninav__sub-footer .qld__cta-link--view-all");
    
    // Toggle function for sub menu and overlay
    function toggleClasses() {
      [dropdownBtn, dropdownMenu, overlay].forEach(element => {
        element.classList.remove(isOpen ? closedClass : openClass);
        element.classList.add(isOpen ? openClass : closedClass);
      });

      // Toggle the overlay for the page
      overlay.classList.remove(isOpen ? overlayClosed : overlayOpen);
      overlay.classList.add(isOpen ? overlayOpen : overlayClosed);

      dropdownMenu.style.transition = ""; 
        if (isOpen) {
            dropdownMenu.style.height = dropdownMenu.scrollHeight + "px";
        } else {
            dropdownMenu.style.height = "0px";
        }  
    }
    
    // Event listner to toggle the toggle function
    dropdownBtn?.addEventListener('click', (event) => {
     event.stopPropagation();
      isOpen = !isOpen;
      toggleClasses();
    });
    
    // Event listner to close the Menu when page clicked outside of menu
    window.addEventListener('click', (event) => {
      if (isOpen && !dropdownInner.contains(event.target)) {
        isOpen = false;
        toggleClasses();
      }
    });

    if (searchForm) {
      searchForm.querySelector('.qld__btn--search').setAttribute('type', 'submit');
      searchForm.querySelectorAll('.qld__btn--search, .qld__text-input').forEach((el) => {
          el.removeAttribute('disabled');
      });
      checkHoneypot();
  }

  /**
     * Check if honeypot field is empty
     * 
     * @memberof module:header
     * @instance
     * @private
     */
  function checkHoneypot() {
    var honeypot = searchForm.querySelector('.qld__text-input--validation');
    honeypot.value = '';

    searchForm.addEventListener('submit', function(event) {
        // Prevent form submission if the honeypot field is filled
        if (honeypot.value !== '') {
            event.preventDefault(); // Stop the form submission
        } else {
            honeypot.removeAttribute('name');
        }
    });
}

    

})();